import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { IStrapiDocument, Onboarding } from 'src/app/interfaces/strapi';

import { PageComponent } from 'src/app/shared/components/page/page.component';
import { UserService } from 'src/app/services/user.service';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { User } from 'src/app/shared/models/user.model';
import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    imports: [
        NgIf,
        RenderMarkdownComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class OnboardingComponent extends PageComponent implements OnInit {
  public override pageData: Onboarding = <Onboarding>{};

  public checkbox = new UntypedFormControl(false, [Validators.required.bind(this)]);

  public changeOnboardingModal = false;

  public showCheckbox = true;

  public checkOnboarding = this.authService.currentUser?.onboarded;

  public onboardingUpdateError = false;

  public accepted = this.checkbox.value;

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly authService: AuthService,
    public readonly userService: UserService,
    public readonly cdr: ChangeDetectorRef
  ) {
    super(titleService, metaService, strapi);

    this.checkbox.valueChanges.subscribe((checkbox_value) => {
      this.accepted = checkbox_value;
      this.cdr.detectChanges();
    });
  }

  ngOnInit(): void {
    this.strapi.getDocumentsByType('onboarding').subscribe({
      next: (data: IStrapiDocument<Onboarding>) => {
        this.parsePageData(data.data.attributes);
        super.setMetas();
        this.onboardingChange();
      },
      error: () => {
        this.pageRetrievalError = true;
      },
    });
  }

  protected override parsePageData(page: Onboarding): void {
    super.parsePageData(page);

    this.pageData = page;

    if (page.intro) this.pageData.intro = String(page.intro);
  }

  public onboardingChange(): void {
    if (!this.checkOnboarding) {
      this.changeOnboardingModal = true;

      const clone = User.fromJson(this.authService.currentUser!);
      clone.acceptedEmail = this.checkbox.value as boolean;
      clone.onboarded = true;

      // make a copy of these values because they'll be lost after the update.
      const accommodationCovered =
        !!this.authService.currentUser?.accommodation.covered;
      const accommodationWellbeing =
        !!this.authService.currentUser?.accommodation.wellbeing;

      this.userService.updateUser(clone, false).subscribe({
        next: () => {
          this.onboardingUpdateError = false;
          if (this.authService.currentUser?.accommodation) {
            // restore the lost values from above
            this.authService.currentUser.accommodation.covered =
              accommodationCovered;
            this.authService.currentUser.accommodation.wellbeing =
              accommodationWellbeing;
            this.authService.afterUserUpdate();
          }
        },
        error: () => {
          this.onboardingUpdateError = true;
          // reset the checkbox back to the value the user had before (shouldn't have changed because the update failed)
          this.checkbox.setValue(this.authService.currentUser?.acceptedEmail);
        },
      });
    }
  }
}
